<template>
    <div id="case">
        <Header></Header>
        <div class="case-img"></div>
    </div>
</template>

<script>
    import Header from '../pages/header/header'
    import {onloadRefresh} from '../utils/imgRefresh'
    export default {
        name: "kaKa",
        components:{
            Header
        },
        mounted() {
            onloadRefresh(this,require(`../assets/kaKa/卡卡城堡.png`))
        }
    }
</script>

<style scoped lang="scss">
@import "../assets/css/public";
</style>
